'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/jsx-handler-names */


/*
Pflichtproperties:
Usable={true/false} 
Text={ "OK" }   
OnClick={ ( )=>{ this.Close();if(this.props.Click){ click(); } }}

optional:
Width={150} style={{ marginTop: '2px !important'}} Float={'right'}
ref={"Register"}
style={{ margin: 25}}
*/
var LinkButton = function (_Component) {
    _inherits(LinkButton, _Component);

    function LinkButton(props) {
        _classCallCheck(this, LinkButton);

        var _this = _possibleConstructorReturn(this, (LinkButton.__proto__ || Object.getPrototypeOf(LinkButton)).call(this, props));

        _this.state = {};
        _this.state.ClassName = _this.props.ClassName;
        return _this;
    }

    _createClass(LinkButton, [{
        key: 'render',
        value: function render() {
            var text = this.props.Text;

            var Tooltip = '';
            if (this.props.Tooltip) {
                Tooltip = _react2.default.createElement(
                    'span',
                    null,
                    this.props.Tooltip
                );
            }

            var className = 'linkButton';
            if (this.state.ClassName) {
                className = this.state.ClassName;
            }
            var inp = _react2.default.createElement(
                'div',
                {
                    onClick: this.props.OnClick,
                    className: className,
                    id: this.props.Id },
                text,
                Tooltip
            );

            return inp;
        }
    }]);

    return LinkButton;
}(_react.Component);

exports.default = LinkButton;